module.exports = __webpack_public_path__ + "img/undraw_Chatting_re_j55r.7895fdb3.svg";